// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-quill/dist/quill.snow.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/dwn.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event, .participants, .error {
    background-color: #FFFFFF;
    gap: 8px; /* Zmniejszono z 48px */
    flex-direction: column;
}
.error {
    border: 1px solid #D82121;
}
.error .title {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.error .warning-wrapper {
    gap: 16px;
    angle: 0 deg;
    opacity: 1;
    padding: 16px;
    background-color: #FFCFCF;
}
.error .warning-wrapper .warning {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.event .title {
    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 150%;
}
.event .subtitle {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
}
.event .form {

}
.event .form .categories-select input[role='combobox'], .event .form .hashtags-select input[role='combobox'] {
    border: transparent !important;
}
.event .form input:focus {
    border: 2px solid #7A1F35 !important;
}
.event .form label {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.event .form input[aria-invalid=false], .event .form textarea[aria-invalid=false] {
    border: 1px solid #DED3D4 !important;
}
.events-header .header-left {
    gap: 8px;
}
.events-header .header-left .header-title {
    color: #1E1517;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0;
}
.header-right input {
    border: 1px solid #5C1628;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    color: #838383;
}
.header-right button {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
}
.events {
    border-collapse: separate !important;
    border-spacing: 0 10px !important;
}

.events td {
    background-color: white !important;
    padding: 12px !important;
    border-radius: 6px !important;
}
.status {
    color: #FFFFFF;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0;

    padding-top: 5px;
    padding-right: 18px;
    padding-bottom: 5px;
    padding-left: 18px;
    border-radius: 5px;
}
.table {
    display: flex;
    flex-direction: column;
    gap: 10px; /* odstęp między wierszami */
}

.row {
    display: grid;
    grid-template-columns: 50px 1fr 150px 180px 120px 180px 100px;
    background: white;
    border-radius: 8px;
    padding: 12px;
    align-items: center;
}
.nav-wrapper {
    border-bottom: 1px solid #ECE4E4;
    padding-bottom: 16px;
    margin-bottom: 0px;
}
.nav {
    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 30px;
    line-height: 110%;
    letter-spacing: -0.6px;
}

input[type='file'].cover-image {
    display: none;
}
label.cover-image {
    width: 100%;
    border-radius: 130px;
    background-color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position-y: 20px;
    background-position-x: 97%;
    border: unset !important;
    height: 60px;

    border: 1px solid #ccc;
    display: inline-block;
    padding: 20px 20px;
    cursor: pointer;
    margin-top: -30px;
}
.ticket-modal header {
    font-family: 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0px;
}
.ticket-modal .info {
    font-family: 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
}

.ticket-modal label {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
}

.ticket-modal input, .ticket-modal textarea {
    border: 1px solid #6E6064;
    border-radius: 12px;
    padding: 8px;
    border-width: 1px;
}
.login-title {
    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 30px;
    line-height: 110%;
    letter-spacing: -0.6px;
    text-align: left;
    color: #1E1517;
}
.login-message {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px !important;
    line-height: 150% !important;
    letter-spacing: 0px;
    text-align: left;
    color: #6E6064;
}
.login-button {
    width: 100% !important;
    height: 52px !important;
    vertical-align: middle;
    border-radius: 12px;
    color: white;
}
.login-button-label {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
    border-radius: unset;
    color: white;
}
.login-register-message {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    color: #1E1517;
}
.login-register-button {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    color: #7A1F35;
    font-size: 15px;
    margin-left: 5px;
}
.login-forgot {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: right;
}
.menu-button {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
}
.setup .title .line {
    border-bottom: 1px solid #ECE4E4;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.setup .title .title {
    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 30px;
    line-height: 110%;
    letter-spacing: -0.6px;
    color: #1E1517;
}
.setup .title .description {
    font-family: 'DM Sans', sans-serif;
    font-weight: 300;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0px;
    color: #1E1517;
}
.header {
    gap: 2px;
}
.header .title {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.header .description {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.comments .title {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.comments .description {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.setup .chakra-form__label {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #1E1517;
}
.setup .chakra-input, .setup .css-nalcay-control, .setup .chakra-textarea {
    border: 1px solid #6E6064;
    border-radius: 12px;
}
.setup .chakra-input:focus-visible,
.setup .css-nalcay-control:hover,
.setup .css-1thsgv7-control:hover,
.setup .chakra-textarea:focus-visible {
    border: 2px solid #7A1F35 !important;
}
.setup .chakra-button[type='submit'] {
    padding-top: 16px;
    padding-right: 32px;
    padding-bottom: 16px;
    padding-left: 32px;
    border-radius: 12px;
    background-color: #7A1F35;
}
.setup .chakra-button[type='submit'] .chakra-text {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
    color: white;
}
.menu-nav .link {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;
    color: #FFFFFF;
    align-content: center;
}
.footer .link {
    cursor: pointer;
}
.ql-container {
    min-height: 35em !important;
}

.ql-editor {
    white-space: pre-wrap !important;
}

/* Edytor opisu w czcionce nowego designu */
.ql-editor, .ql-container { font-family: "DM Sans", system-ui, sans-serif !important; font-size: 15px; }
.ql-toolbar.ql-snow, .ql-container.ql-snow { border-color: #DED3D4 !important; }
.ql-toolbar.ql-snow { border-radius: 12px 12px 0 0; }
.ql-container.ql-snow { border-radius: 0 0 12px 12px; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,QAAQ,EAAE,uBAAuB;IACjC,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,SAAS;IACT,YAAY;IACZ,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,yDAAyD;IACzD,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;;AAEA;AACA;IACI,8BAA8B;AAClC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,QAAQ;AACZ;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,4BAA4B;AAC3C;;AAEA;IACI,aAAa;IACb,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,yDAAyD;IACzD,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,yDAAwC;IACxC,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;;IAEZ,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,yDAAyD;IACzD,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yDAAyD;IACzD,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,QAAQ;AACZ;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;;;;IAII,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAGA,2CAA2C;AAC3C,4BAA4B,wDAAwD,EAAE,eAAe,EAAE;AACvG,6CAA6C,gCAAgC,EAAE;AAC/E,sBAAsB,4BAA4B,EAAE;AACpD,wBAAwB,4BAA4B,EAAE","sourcesContent":[".event, .participants, .error {\n    background-color: #FFFFFF;\n    gap: 8px; /* Zmniejszono z 48px */\n    flex-direction: column;\n}\n.error {\n    border: 1px solid #D82121;\n}\n.error .title {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-style: SemiBold;\n    font-size: 20px;\n    leading-trim: NONE;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.error .warning-wrapper {\n    gap: 16px;\n    angle: 0 deg;\n    opacity: 1;\n    padding: 16px;\n    background-color: #FFCFCF;\n}\n.error .warning-wrapper .warning {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    leading-trim: NONE;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.event .title {\n    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 150%;\n}\n.event .subtitle {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n}\n.event .form {\n\n}\n.event .form .categories-select input[role='combobox'], .event .form .hashtags-select input[role='combobox'] {\n    border: transparent !important;\n}\n.event .form input:focus {\n    border: 2px solid #7A1F35 !important;\n}\n.event .form label {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.event .form input[aria-invalid=false], .event .form textarea[aria-invalid=false] {\n    border: 1px solid #DED3D4 !important;\n}\n.events-header .header-left {\n    gap: 8px;\n}\n.events-header .header-left .header-title {\n    color: #1E1517;\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 100%;\n    letter-spacing: 0;\n}\n.header-right input {\n    border: 1px solid #5C1628;\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0;\n    color: #838383;\n}\n.header-right button {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0;\n    vertical-align: middle;\n}\n.events {\n    border-collapse: separate !important;\n    border-spacing: 0 10px !important;\n}\n\n.events td {\n    background-color: white !important;\n    padding: 12px !important;\n    border-radius: 6px !important;\n}\n.status {\n    color: #FFFFFF;\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 100%;\n    letter-spacing: 0;\n\n    padding-top: 5px;\n    padding-right: 18px;\n    padding-bottom: 5px;\n    padding-left: 18px;\n    border-radius: 5px;\n}\n.table {\n    display: flex;\n    flex-direction: column;\n    gap: 10px; /* odstęp między wierszami */\n}\n\n.row {\n    display: grid;\n    grid-template-columns: 50px 1fr 150px 180px 120px 180px 100px;\n    background: white;\n    border-radius: 8px;\n    padding: 12px;\n    align-items: center;\n}\n.nav-wrapper {\n    border-bottom: 1px solid #ECE4E4;\n    padding-bottom: 16px;\n    margin-bottom: 0px;\n}\n.nav {\n    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 110%;\n    letter-spacing: -0.6px;\n}\n\ninput[type='file'].cover-image {\n    display: none;\n}\nlabel.cover-image {\n    width: 100%;\n    border-radius: 130px;\n    background-color: #ffffff;\n    background-image: url('/public/dwn.svg');\n    background-repeat: no-repeat;\n    background-position-y: 20px;\n    background-position-x: 97%;\n    border: unset !important;\n    height: 60px;\n\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 20px 20px;\n    cursor: pointer;\n    margin-top: -30px;\n}\n.ticket-modal header {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 150%;\n    letter-spacing: 0px;\n}\n.ticket-modal .info {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    text-align: center;\n}\n\n.ticket-modal label {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n}\n\n.ticket-modal input, .ticket-modal textarea {\n    border: 1px solid #6E6064;\n    border-radius: 12px;\n    padding: 8px;\n    border-width: 1px;\n}\n.login-title {\n    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 110%;\n    letter-spacing: -0.6px;\n    text-align: left;\n    color: #1E1517;\n}\n.login-message {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px !important;\n    line-height: 150% !important;\n    letter-spacing: 0px;\n    text-align: left;\n    color: #6E6064;\n}\n.login-button {\n    width: 100% !important;\n    height: 52px !important;\n    vertical-align: middle;\n    border-radius: 12px;\n    color: white;\n}\n.login-button-label {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0;\n    vertical-align: middle;\n    border-radius: unset;\n    color: white;\n}\n.login-register-message {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    text-align: center;\n    color: #1E1517;\n}\n.login-register-button {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    text-align: center;\n    color: #7A1F35;\n    font-size: 15px;\n    margin-left: 5px;\n}\n.login-forgot {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    text-align: right;\n}\n.menu-button {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 100%;\n    letter-spacing: 0;\n    vertical-align: middle;\n}\n.setup .title .line {\n    border-bottom: 1px solid #ECE4E4;\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n}\n.setup .title .title {\n    font-family: 'Bricolage Grotesque', 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 30px;\n    line-height: 110%;\n    letter-spacing: -0.6px;\n    color: #1E1517;\n}\n.setup .title .description {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.header {\n    gap: 2px;\n}\n.header .title {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.header .description {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.comments .title {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.comments .description {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.setup .chakra-form__label {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    letter-spacing: 0px;\n    color: #1E1517;\n}\n.setup .chakra-input, .setup .css-nalcay-control, .setup .chakra-textarea {\n    border: 1px solid #6E6064;\n    border-radius: 12px;\n}\n.setup .chakra-input:focus-visible,\n.setup .css-nalcay-control:hover,\n.setup .css-1thsgv7-control:hover,\n.setup .chakra-textarea:focus-visible {\n    border: 2px solid #7A1F35 !important;\n}\n.setup .chakra-button[type='submit'] {\n    padding-top: 16px;\n    padding-right: 32px;\n    padding-bottom: 16px;\n    padding-left: 32px;\n    border-radius: 12px;\n    background-color: #7A1F35;\n}\n.setup .chakra-button[type='submit'] .chakra-text {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0;\n    vertical-align: middle;\n    color: white;\n}\n.menu-nav .link {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 18px;\n    leading-trim: NONE;\n    line-height: 100%;\n    letter-spacing: 0;\n    vertical-align: middle;\n    color: #FFFFFF;\n    align-content: center;\n}\n.footer .link {\n    cursor: pointer;\n}\n.ql-container {\n    min-height: 35em !important;\n}\n\n.ql-editor {\n    white-space: pre-wrap !important;\n}\n@import 'react-quill/dist/quill.snow.css';\n\n/* Edytor opisu w czcionce nowego designu */\n.ql-editor, .ql-container { font-family: \"DM Sans\", system-ui, sans-serif !important; font-size: 15px; }\n.ql-toolbar.ql-snow, .ql-container.ql-snow { border-color: #DED3D4 !important; }\n.ql-toolbar.ql-snow { border-radius: 12px 12px 0 0; }\n.ql-container.ql-snow { border-radius: 0 0 12px 12px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
